function calcInset(element, container) {
  var inset = {
    x: 0,
    y: 0
  };
  var current = element;
  while (current && current !== container) {
    if (current instanceof HTMLElement) {
      inset.x += current.offsetLeft;
      inset.y += current.offsetTop;
      current = current.offsetParent;
    } else if (current instanceof SVGGraphicsElement && "getBBox" in current) {
      var _current$getBBox = current.getBBox(),
        top = _current$getBBox.top,
        left = _current$getBBox.left;
      inset.x += left;
      inset.y += top;
      /**
       * Assign the next parent element as the <svg /> tag.
       */
      while (current && current.tagName !== "svg") {
        current = current.parentNode;
      }
    }
  }
  return inset;
}
export { calcInset };